module.exports = __webpack_public_path__ + "static/img/1-机械设备专家.db9b86de.jpg";